export default {"src":"/_next/static/media/robot.8da8b5d0.svg","height":245,"width":244};